import MagnifyingGlass from '../../src/legacy/MagnifyingGlass';
export default MagnifyingGlass;
